module.exports = __webpack_public_path__ + "media/images/childcare/card-mobile-4abb4b1f8918343387febe2eef924993.jpg";